import React from 'react';

const PREVIEW_MESSAGES = [
  {
    role: 'user',
    text: 'Why do leaves turn orange in autumn?',
  },
  {
    role: 'assistant',
    text: 'Good one — let’s work it out. You already know leaves look green because of chlorophyll. In autumn there’s less sunlight, so what do you think the tree does with its food factory?',
  },
  {
    role: 'user',
    text: 'Shuts it down?',
  },
  {
    role: 'assistant',
    text: 'Exactly. And once the green fades, colours that were hiding all along show through. Which colour do you think was there the whole time?',
  },
];

export default function ChatPreview() {
  return (
    <div className="relative mx-auto w-full max-w-md lg:max-w-none">
      <div className="overflow-hidden rounded-card border border-brand-line bg-[#343541] shadow-brand-lg">
        <div className="flex items-center gap-2 border-b border-white/10 bg-[#202123] px-3 py-2.5">
          <span className="h-2.5 w-2.5 rounded-full bg-[#ff5f57]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#febc2e]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[#28c840]" />
          <span className="ml-2 truncate text-xs text-white/50">schoolcracked.com/chat</span>
        </div>
        <div className="space-y-3 p-4">
          {PREVIEW_MESSAGES.map((msg) =>
            msg.role === 'user' ? (
              <div key={msg.text} className="flex justify-end">
                <div className="max-w-[85%] rounded-2xl rounded-br-md bg-[#40414f] px-3.5 py-2.5 text-[13px] leading-relaxed text-[#ececf1]">
                  {msg.text}
                </div>
              </div>
            ) : (
              <div key={msg.text} className="flex gap-2.5">
                <div className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#0da37f] text-[10px] font-bold text-white">
                  SC
                </div>
                <div className="min-w-0 flex-1 text-[13px] leading-relaxed text-[#ececf1]">
                  {msg.text}
                </div>
              </div>
            )
          )}
          <div className="rounded-2xl border border-white/10 bg-[#40414f] px-3 py-2.5 text-[12px] text-white/40">
            Ask anything…
          </div>
        </div>
      </div>
      <div
        className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-brand-sky/30 blur-2xl"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-8 -left-8 h-28 w-28 rounded-full bg-brand-coral/25 blur-2xl"
        aria-hidden
      />
    </div>
  );
}
